<template>
  <v-flex xs12>
    <v-flex
      md10
      offset-md1
      sm12
      offset-sm0
    >
      <v-layout
        :mt-5="$vuetify.breakpoint.smAndUp"
        class="stepper__wrapper"
        mb-0
        fill-height
      >
        <v-flex
          v-if="$vuetify.breakpoint.smAndUp"
          pa-4
          sm3
          class="stepper__header"
        >
          <TableOfContent :TOCData="addWarehouseTOC">
            <template slot="backButton">
              <a
                v-if="editMode"
                class="link_iconed"
                @click="moveToCard()"
              >
                <v-icon>keyboard_arrow_left</v-icon> {{ $t('warehouses.buttons.back_to_card') }}</a>
              <a
                v-else
                class="link_iconed"
                @click="moveToList()"
              >
                <v-icon>keyboard_arrow_left</v-icon> {{ $t('warehouses.buttons.back') }}</a>
            </template>
          </TableOfContent>
        </v-flex>
        <v-dialog
          v-else
          v-model="contentDialog"
          hide-overlay
          persistent
          scrollable
          fullscreen
        >
          <v-layout
            style="background: #fff; overflow: scroll"
            fill-height
          >
            <TableOfContent
              :TOCData="addWarehouseTOC"
              @closeDialog="contentDialog = false"
            >
              <template slot="backButton">
                <a
                  v-if="editMode"
                  class="link_iconed"
                  @click="moveToCard()"
                >
                  <v-icon>keyboard_arrow_left</v-icon>
                  {{ $t('warehouses.buttons.back_to_card') }}</a>
                <a
                  v-else
                  class="link_iconed"
                  @click="moveToList()"
                >
                  <v-icon>keyboard_arrow_left</v-icon> {{ $t('warehouses.buttons.back') }}</a>
              </template>
            </TableOfContent>
          </v-layout>
        </v-dialog>
        <v-flex
          px-4
          pt-4
          pb-0
          xs12
          sm9
          class="white"
        >
          <v-layout
            v-if="$vuetify.breakpoint.xsOnly"
            align-center
            justify-space-between
            pb-3
          >
            <v-flex>
              <a
                class="link_iconed"
                @click="moveToList"
              >
                <v-icon>keyboard_arrow_left</v-icon>
                {{ $t('warehouses.buttons.back') }}
              </a>
            </v-flex>
            <v-flex shrink>
              <a @click="contentDialog = true">
                <BaseIcon>
                  <MenuIcon />
                </BaseIcon>
              </a>
            </v-flex>
          </v-layout>
          <v-flex>
            <BaseInfo
              v-view="viewHandler"
              :read-only="readOnly"
            />
            <locationData
              v-view="viewHandler"
              :read-only="readOnly"
            />
            <AdditionalParameters
              v-view="viewHandler"
              :read-only="readOnly"
            />
            <WarehouseManager
              v-view="viewHandler"
              :read-only="readOnly"
            />
            <AdditionalNotes
              v-view="viewHandler"
              :read-only="readOnly"
              @emitNotes="getAdditionalNotes($event)"
            />
            <WarehousePreview
              v-view="viewHandler"
              :warehouse-type="1"
            />
            <EndButtons
              :edit-mode="editMode"
              :warehouse-type="1"
              :rejon-has-warehouse="rejonHasWarehouse"
              :read-only="readOnly"
            />
            <ScrollBottomButton />
          </v-flex>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-flex>
</template>

<script>
import BaseInfo from '@/components/warehouse/warehouseData/BaseInfo';
import AdditionalParameters from '@/components/warehouse/warehouseData/AdditionalParameters';
import WarehouseManager from '@/components/warehouse/warehouseData/WarehouseManager';
import AdditionalNotes from '@/components/warehouse/warehouseData/AdditionalNotes';
import locationData from '@/components/warehouse/AddRejonWarehouse/locationData';
import EndButtons from '@/components/warehouse/EndButtons';
import BaseIcon from '@/icons/BaseIcon';
import MenuIcon from '@/icons/MenuIcon';
import TableOfContent from '@/components/widgets/TableOfContent';
import addWarehouseTOC from '@/constants/warehouse/addWarehouseTOC';
import WarehousePreview from '@/components/warehouse/WarehousePreview';

import { mapFields } from 'vuex-map-fields';
import warehousesAcceptPermissions from '@/mixins/warehousesAcceptPermissions';
import ScrollBottomButton from '@/components/widgets/ScrollBottomButton';

export default {
    name: 'WarehouseData',
    components: {
        ScrollBottomButton,
        locationData,
        BaseInfo,
        AdditionalParameters,
        WarehouseManager,
        AdditionalNotes,
        EndButtons,
        BaseIcon,
        MenuIcon,
        TableOfContent,
        WarehousePreview
    },
    mixins: [warehousesAcceptPermissions],
    inject: ['$validator'],
    props: {
        editMode: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            addWarehouseTOC,
            contentDialog: false
        };
    },
    computed: {
        ...mapFields('warehouses', ['addWarehouse.additionalNote']),
        rejonHasWarehouse () {
            return this.$store.getters['warehouses/getRejonHasWarehouse'];
        },
        readOnly () {
            if (this.canEdit || this.canEditPublishedWarehouse) {
                return false;
            }
            return this.rejonHasWarehouse;
        },
        wioStructId () {
            return this.$store.getters['warehouses/getSelectedRejon'].id;
        }
    },
    beforeCreate () {
        this.$store.commit('warehouses/setCurrentSelectorName', 'baseInfo');
    },
    created () {
        if (this.editMode) {
            this.addWarehouseTOC[0][0].name = 'edit-warehouse-data';
        } else {
            this.addWarehouseTOC[0][0].name = 'warehouse-data';
        }
    },
    methods: {
        viewHandler (e) {
            if (e.scrollPercent < 1) {
                if (e.target.rect.top <= 350) {
                    this.$store.commit('warehouses/setCurrentSelectorName', e.target.element.id);
                }
            } else {
                if (e.percentTop <= 1) {
                    this.$store.commit('warehouses/setCurrentSelectorName', e.target.element.id);
                }
            }
        },
        getAdditionalNotes (event) {
            this.additionalNote = event;
        },
        moveToList () {
            this.$router.push({ name: 'warehouse-list' });
        },
        moveToCard () {
            this.$router.go(-1);
        }
    }
};
</script>

<style scoped></style>
